<template>
  <ul class="item_main">
    <li>
      <span>当前状态:</span>
      <p>{{ info.xzt ? info.xzt : "-" }}</p>
    </li>
    <li>
      <span>申请日期:</span>
      <p>{{ info.ydrq ? info.ydrq : "-" }}</p>
    </li>
    <li>
      <span>生效学期:</span>
      <p>{{ info.sqsxrq ? info.sqsxrq : "-" }}</p>
    </li>
    <li>
      <span>异动类别:</span>
      <p>{{ info.ydlbm ? info.ydlbm : "-" }}</p>
    </li>
    <li>
      <span>院系名称:</span>
      <p>{{ info.sqyxmc ? info.sqyxmc : "-" }}</p>
    </li>
    <li>
      <span>所在年级:</span>
      <p>{{ info.sqdqszj ? info.sqdqszj : "-" }}</p>
    </li>
    <li>
      <span>学籍状态:</span>
      <p>{{ info.xxj ? info.xxj : "-" }}</p>
    </li>
    <li>
      <span>专业名称:</span>
      <p>{{ info.sqzymc ? info.sqzymc : "-" }}</p>
    </li>
    <li>
      <span>培养层次:</span>
      <p>{{ info.sqppccmc ? info.sqppccmc : "-" }}</p>
    </li>
    <li>
      <span>学&emsp;&emsp;制:</span>
      <p>{{ info.sqxz ? info.sqxz : "-" }}</p>
    </li>
    <li>
      <span>班级名称:</span>
      <p>{{ info.bj ? info.bj : "-" }}</p>
    </li>
    <li>
      <span>异动文号:</span>
      <p>{{ info.ydwh ? info.ydwh : "-" }}</p>
    </li>
    <li>
      <span>发文日期:</span>
      <p>{{ info.fwrq ? info.fwrq : "-" }}</p>
    </li>
    <li>
      <span>毕业专业:</span>
      <p>{{ info.byzy ? info.byzy : "-" }}</p>
    </li>
    <li>
      <span>异动去向:</span>
      <p>{{ info.sqydqx ? info.sqydqx : "-" }}</p>
    </li>
    <template v-if="info.ydlbdm == 11">
      <li>
        <span>休学开始时间:</span>
        <p>{{ info.xxksrq ? info.xxksrq : "-" }}</p>
      </li>
      <li>
        <span>休学结束时间:</span>
        <p>{{ info.xxjsrq ? info.xxjsrq : "-" }}</p>
      </li>
    </template>
  </ul>
</template>

<script>
export default {
  props: {
    info: {
      type: Object,
      default: () => {}
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/newPages/teacher/xjydsh/mode/modeYdhqk.vue